interface DisputeFields {
  openRegZDispute?: boolean
  hasOpenDispute?: boolean
  hasStandardDisputeOpen?: boolean
}

export const hasAnyOpenDispute = (fields: DisputeFields): boolean => {
  return fields.openRegZDispute === true || fields.hasOpenDispute === true || fields.hasStandardDisputeOpen === true
}
